import { useState, useEffect } from "react";
import type { ILocaleConfig } from "@/types/localeTypes";
import { fetchAvailableLocales } from "@/services/localeService";

interface IUseLocalesResult {
  locales: ILocaleConfig[];
  loading: boolean;
  error: Error | null;
  retry: () => Promise<void>;
}

export function useLocales(): IUseLocalesResult {
  const [locales, setLocales] = useState<ILocaleConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const loadLocales = async (): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchAvailableLocales();
      setLocales(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Failed to load locales"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void loadLocales();
  }, []);

  return {
    locales,
    loading,
    error,
    retry: loadLocales,
  };
}
